export default "__VITE_ASSET__2V3Lv8le__"